export const orderDetailAccountingPageCode = {
    SUMMARY: 'SUMMARY',
    FINANCE: 'FINANCE'
}

export const orderDetailAccountingPage = [
    orderDetailAccountingPageCode.SUMMARY,
    orderDetailAccountingPageCode.FINANCE
]

export const orderDetailAccountingPageName = {
    SUMMARY: 'Summary',
    FINANCE: 'Finance'
}